import { ILicenceData } from "./ILicenceData";

export interface IAuthentication {
    email: string;
    firstname: string;
    lastname: string;
    token:string;
    role:UserRole;
    companyId: number;
    userId:number;
    licenceEndDates?:Date;
    licencePackage: ILicenceData;
}

export enum UserRole {
    Sayman = 0,
    Personel = 1,
    Operator = 2,
    Admin=3,
    AltisAdmin = 4,
    AssetManager = 5,
  }